
  if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();
      this.form = this.querySelector('form');
      this.form.querySelector('[name=id]').disabled = false;
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      this.cart = document.querySelector('#minicart');
      this.submitButton = this.querySelector('[type="submit"]');
      this.hideErrors = this.dataset.hideErrors === 'true';
    }

    onSubmitHandler(evt) {
      evt.preventDefault();
      if (this.submitButton.getAttribute('aria-disabled') === 'true') return;
      this.handleErrorMessage();
      this.submitButton.setAttribute('aria-disabled', true);
      this.submitButton.classList.add('loading');
      this.querySelector('.loading-overlay__spinner')?.classList.remove('hidden');
      this.submitButton.querySelector('[data-addtocart-text]').classList.add('hidden');
      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];
      const formData = new FormData(this.form);
      if (this.cart) {
        formData.append('sections', this.cart.getSectionsToRender().map((section) => section.id));
        formData.append('sections_url', window.location.pathname);
      
      }
      config.body = formData;
      fetch(`${routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {
        
          if (response.status) {
            publish(PUB_SUB_EVENTS.cartError, {source: 'product-form', productVariantId: formData.get('id'), errors: response.description, message: response.message});
            this.handleErrorMessage(response.description);
           
            this.submitButton.setAttribute('aria-disabled', true);
            this.error = true;
            return;
          } else if (!this.cart) {
  const toast = document.createElement('div');
  toast.textContent = 'Ajouté au panier ✓';
  toast.className = 'cart-added-toast';
  document.body.appendChild(toast);

  setTimeout(() => {
    toast.remove();
  }, 2500);

  return;
}
          if (!this.error) publish(PUB_SUB_EVENTS.cartUpdate, {
  source: 'product-form',
  productVariantId: formData.get('id')
});

this.error = false;

if(document.querySelector('#product-quick-view') && document.querySelector('#product-quick-view').classList.contains("active")){
  document.querySelector('#product-quick-view').classList.remove("active")
}
if (this.cart && typeof this.cart.renderContents === 'function') {
  this.cart.renderContents(response);
}

const miniCart = document.querySelector('mini-cart');

if (miniCart) {
  miniCart.openDrawer({
    preventDefault: () => {},
    currentTarget: miniCart
  });
}
const toast = document.createElement('div');
toast.textContent = 'Ajouté au panier ✓';
toast.className = 'cart-added-toast';
document.body.appendChild(toast);

setTimeout(() => {
  toast.remove();
}, 2500);
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          this.submitButton.classList.remove('loading');
          this.submitButton.querySelector('[data-addtocart-text]').classList.remove('hidden');
          if (this.cart && this.cart.classList.contains('is-empty'))
          this.cart.classList.remove('is-empty');
          if (!this.error) this.submitButton.removeAttribute('aria-disabled');
          this.querySelector('.loading-overlay__spinner')?.classList.add('hidden');
       
        });
    }

    handleErrorMessage(errorMessage = false) {
     if (this.hideErrors) return;
      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      if (!this.errorMessageWrapper) return;
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');
      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);
      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }
  });
}document.addEventListener('click', async (event) => {
  const button = event.target.closest('.catalog-cart-button');

  if (!button) return;

  event.preventDefault();

  const variantId = button.dataset.variantId;

  if (!variantId) return;

  try {
    const response = await fetch(`${window.Shopify.routes.root}cart/add.js`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        items: [
          {
            id: Number(variantId),
            quantity: 1
          }
        ]
      })
    });

    if (!response.ok) {
      throw new Error('Erreur lors de l’ajout au panier');
    }

    await response.json();
const cartResponse = await fetch(`${window.Shopify.routes.root}cart.js`);
const cart = await cartResponse.json();

document.querySelectorAll('[data-header-cart-count]').forEach((counter) => {
  counter.textContent = cart.item_count;

  if (cart.item_count > 0) {
    counter.classList.remove('hidden');
  } else {
    counter.classList.add('hidden');
  }
});
    const toast = document.createElement('div');
    toast.textContent = 'Ajouté au panier ✓';
    toast.className = 'cart-added-toast';
    document.body.appendChild(toast);

    setTimeout(() => {
      toast.remove();
    }, 2500);

  } catch (error) {
    console.error(error);
  }
});